import { Box, Spinner } from '@99designs/emu';

export const LoadingSpinner = () => (
    <Box display="flex" justifyContent="center" paddingTop="2bu">
        <Spinner size="large" data-testid="spinner" />
    </Box>
);
